import { bl_fi_mst_item_ext_RowClass, bl_fi_mst_item_line_RowClass } from '../../../dbschema';
import { bl_fi_item_comp_branch_link_RowClass } from '../../../dbschema/bl_fi_item_comp_branch_link.model';
import { BaseContainerModel } from '../../base-container.model';

export class ItemCompanyBranchLinkContainerModel extends BaseContainerModel {
  bl_fi_item_comp_branch_link: bl_fi_item_comp_branch_link_RowClass = new bl_fi_item_comp_branch_link_RowClass();
}

export class ItemCompanyBranchLinkQueryCriteria {
  offset: number;
  limit: number;
  orderBy: string;
  order: string;
  keyword: string;
  descr: string;
  status: string;
  fi_item_hdr_guid: string;
}
